export const Gas = "gas";
export const Electricity = "electricity";
export const Fuel = "Fuel";
export const GasNew = "Gas";
export const ElectricityNew = "Electricity";
export const EvCharging = "EvCharging";
export const CylinderGas = "CylinderGas";